module.exports = {
  // ================ TEXTS FOR SITE ELEMENTS ================
  p: {
    prgtitle: "SMART-TEAM-DEV-PORTAL [TR]",
    moredetailed: "Devamını oku...",
    loadingdata: "Veri yükleniyor...",
    processing: "İşleme...",
    send: "Göndermek",
    changetheme: "Renk temasını değiştir",
    usermenu: "Kullanıcı menüsü",
    userpage: "Kullanıcı ayarları",
    userexit: "<i class='fa fa-sign-out'></i>&nbsp;&nbsp;Dışarı çıkmak",
    userlogin: "<i class='fa fa-sign-in'></i>&nbsp;&nbsp;İçeri gel",
    gotoportal: "<i class='fa fa-share-square-o'></i>&nbsp;PORTAL",
    usrexit: "Dışarı çıkmak",
    usrlogin: "İçeri gel",
    fieldlogin: "Giriş yapmak",
    fieldpass: "Şifre",
    buttonlogin: "İçeri gel",
    authFormTitle: "Kullanıcı Yetki Formu",
    redirection: "Yönlendirme...",
    changelng: "Change language",
    noscript: "SİTENİN ÇALIŞMASI İÇİN, Script YÜRÜTÜLMESİNE İZİN VERMENİZ GEREKİR",
    error: "Ошибка",
    serverLogsTitle: "Sistem günlükleri"
  },
  ymaps: {
    pageTitle: "= Yandex-Maps =",
    theRouteBuilt: "Rota inşa edildi",
    cantBuiltTheRoute: "Bir rota inşa edemem. Sorgustring doğru değil, olmalı: ?from=...&to=....&through=",
    mileage: "Uzunluk, km = ",
    time: "Seyahat Süresi, saat = ",
    ymapsModuleWasLoaded: "Yandex-Maps modülü yüklendi",
    yandexMapsIsNotLoaded: "Yandex-Maps modülü yüklenmedi. Belki yönetici tarafından kapatılır",
    couldNotBuildAroute: "Bir rota inşa edemedi",
    pageNotFound: "Sayfa %ymapsLink% mevcut değil",
    minimumAddressesRequired: "'addresses' dizisindeki adres numarası en az 2 olmalıdır"
  },
  e: {
    missingADhash: "Srvbg-server yetkilendirmenizi reddetti. Dahili Ağda olmanız gerekir. VPN'inizi açmayı mı unuttunuz?",
    nullLoginOrPass: "Gerekli bağımsız değişkenler eksik - login & pass",
    incorrectOldPassword: "Yanlış eski şifre",
    userLoggedFailed: "Yetkilendirme Hatası",
    incorrectAuthCode: "Geçersiz yetkilendirme kodu",
    lifetimeAuthCode: "Yetkilendirme kodunun süresi doldu",
    candFindOnlineComputer: "Kullanıcının bilgisayarını 'çevrimiçi' durumda bulamıyorum",
    errorPageTitle: "Sayfayı oluşturmaya çalışırken sunucu tarafı hatası",
    fileNotFound: "Dosya bulunamadı",
    fileconversionerror: "Dosya dönüştürme hatası",
    pserror: "PowerShell komut dosyası yürütme hatası",
    userIsNotFound: "Kullanıcı bulunamadı",
    userIsNotInInternalNetwork: "Kullanıcı şirketin dahili ağında değil",
    userIsNotInAllowedGroupsForSiteLogin: "Kullanıcı sitede yetkilendirme için izin verilen gruba dahil değil",
    thisSiteAllowOnlyADauthentication: "Bu site yalnızca Active Directory'den kullanıcı kimlik doğrulamasına izin verir!",
    userDoesntHavePhoneAuthType: "Kullanıcı telefon kodu yetkilendirmesini devre dışı bıraktı",
    userDoesntHaveMessengersIDs: "Kullanıcının (ayarlarda veya ActiveDirectory'de) belirtilen herhangi bir mesajlaşma kimliği yok (viberid, whatsappid, telegramid)",
    cantsendmessage: "Mesaj gönderemiyorum",
    incorrentfields: "Tüm alanlar doğru şekilde doldurulmamış",
    qrcodenouri: "QR kod kodlaması için URI aktarılmadı",
    banned: "Engellendin!",
    incorrectHostName1: "Yanlış ana bilgisayar adı",
    incorrectHostName2: "Belki de bu DNS sunucusunun bir hatasıdır. 'ipconfig /flushdns' komutunu gerçekleştirin, tarayıcı önbelleğini (Ctrl + Shift + Del) temizleyin, tarayıcıyı yeniden başlatın",
    userDisabled: "Kullanıcı devre dışı bırakıldı",
    chartnodata: "Çizim verileri aktarılmadı",
    adTestError: "ActiveDirectory'e bağlanırken hata oluştu",
    adUserCantChangePwdThisWay: "ActiveDirectory kullanıcısı şifreyi bu şekilde değiştiremez. Ctrl+Alt+Del tuşlarına basın ve 'Şifreyi değiştir'i seçin",
    unknownError: "Bilinmeyen hata",
    somethingWrong: "Bir şeyler ters gitti",
    recIsNotFoundInDB: "Kayıt kümesi veritabanında bulunamadı",
    emptyDatabaseResult: "Veritabanına istek boş bir dizi döndürdü",
    cryptoError2: "Verileri istemciden deşifre etmek mümkün değildi. Yanlış anahtar, veri veya iv!"
  },
  w: {
    userLoggedError1: "Bu son bir saatte ",
    userLoggedError2: "'inci girişim oldu. 5 kez yanlış veri gönderirseniz engellenirsiniz!",
    apiOnlyForLAN: "API işlevlerine yalnızca yerel ağdaki kullanıcılar veya Güvenilir harici IP adresleri için izin verilir",
    attentionban: "Henüz engellenmediniz. Ancak bu olursa, yalnızca site sahibi sizi kara listeden çıkarabilir.",
    nothingUpdated: "Hiçbir şey güncellenmedi",
    onlyOneTimeCanCallSSOauthorization: "SSO aracılığıyla yalnızca bir kez giriş yapabilirsiniz",
    resetAppSettingsNothing: "'Uygulama adı' uygulamasının veritabanındaki ayarları eksikti (fabrika ayarları zaten yüklendi)",
    thisLoginAlreadyExistInAD: "Bu kullanıcı adı zaten mevcut! Yeni değer girin",
    notYetDeveloped: "Henüz gelişmedi..."
  },
  i: {
    userLoggedSuccess: "Başarıyla giriş yaptınız",
    messagesent: "Mesajı gönderildi",
    finish: "Tamamlamak",
    updatedFields: "Güncellenen alanlar: ",
    newADuserHasBeenCreated: "Yeni bir ActiveDirectory kullanıcısı başarıyla oluşturuldu!",
    userIsInInternalNetwork: "Kullanıcı şirketin dahili ağındadır",
    adTestSuccess: "ActiveDirectory'e bağlantı başarılı oldu",
    settingsHasBeenSaved: "Ayarlar kaydedildi",
    generalSettingsHasBeenSaved: "Ayarlar kaydedildi. ",
    programWillRestart: "Program sunucu tarafında yeniden başlatılacak",
    passwordWasChangedSuccess: "Parola başarıyla değiştirildi",
    successDeleted: "Başarıyla silindi",
    successUpdated: "Başarıyla güncellendi",
    successCreated: "Başarıyla oluşturuldu",
    successOperation: "Başarıyla tamamlandı",
    nothingHasChanged: "Hiçbir şey değişmedi"
  },
  unit: {
    pcs: "adet",
    m: "m",
    m2: "m²",
    m3: "m³",
    mm: "mm",
    kg: "kg"
  },
  // ================ IMAGES ================
  img: {
    programmerisworking: { title: "Sitenin bu bölümünde bir programcı çalışıyor.", src: "/img/general/programmer-is-working.png" }
  },
  ag: {
    successDeleted: "Başarıyla silindi",
    successUpdated: "Başarıyla güncellendi",
    successCreated: "Başarıyla oluşturuldu",
    successOperation: "Başarıyla tamamlandı"
  },
  gpt: {
    chatGPTdisabled: "ChatGPT, program ayarlarında Yönetici tarafından devre dışı bırakıldı",
    chatGPTtoken: "Yapılandırmada API anahtarını ayarlamanız gerekir",
    c: "Yapılandırmada api.openai.com'a erişim sağlamak için Proxy-server'ı ayarlamanız gerekir.",
    userDoesntHaveEnoughRightsToWorkWithGPT: "ChatGPT kullanarak bu tabloyu analiz etmek için yeterli hakınız yok",
    userDoesntHaveEnoughRightsToRunVoiceCommands: "Ses komutlarını çalıştırmak için yeterli hakınız yok",
    thereAreNoDataForAnalysis: "Analiz için veri yok",
    incorrectRequest: "Yanlış istek",
    incorrectDatePeriod: "Bir talep oluşturmak için yanlış tarihler",
    speechRecognitionError: "Konuşma tanıma hatası",
    speechRecognitionNull: "Kaydedilmiş bir mesaj yok. Tanıyacak hiçbir şey yok",
    undefinedEmployee: "Hangi çalışanların söz konusu olduğunu belirlemek mümkün değildi",
    undefinedCommand: "Komut, izin verilen eylemler listesine dahil değildir. Bir ses asistanı çağırmadan önce izin verilen komutlar listesine göz atın",
    noAnswerFromChatGPT: "Chatgpt'ten cevap yok",
    ansWasCopiedToBuffer: "AI cevabı panoya kopyalanır",
    copyToBufferError: "Panoya kopyalarken bir hata vardı",
    voiceRecordingStart: "Mikrofondan sesin bir kaydı var",
    voiceRecordingStop: "Sesin kaydı durdu",
    micPermissionsError: "Cihazınızın mikrofonuna erişme hakkı yok",
    tooltip1: "ChatGPT kullanılarak bu tablonun veri analizi",
    tooltip2: "Ses komutunu çalıştırın"
  },
  viber: {
    viberBotOnSubscribe: `Merhaba! Ben bir Viber botuyum. Güncel görevler ve diğer bildirimler hakkında benden Viber üzerinden mesaj alabileceksiniz. 
     Ama önce seni tanımlamam gerekiyor. Bana telefon numaranızı şu formatta gönderin: +79100000000`,
    viberBotNeedSubscribe: "Öncelikle seni tanımlamam gerekiyor. Telefon numaranızı şu formatta gönderin: +79100000000",
    viberBotUnderstandOnlyTextMessages: "Üzgünüm. Yalnızca kısa mesajları anlıyorum",
    viberBotDummyAnswer: "Bu sohbette yorum yazmaya gerek yoktur. Zaten onları kimse görmeyecek. Sohbet yalnızca tek yönlü çalışır Bot -> Viber",
    viberBotIsAlreadyKnownYou: "Viber bot'ta zaten kayıtlısınız",
    userWithThisPhoneNotFound: "'users' veritabanında bu telefon numarasına sahip bir kullanıcı bulunamadı",
    viberBotHello1: "Merhaba, ",
    viberBotHello2: "! Kimliğiniz: ",
    viberBotHello3: ". Bu sohbete başarıyla bağlandınız ve artık Viber botundan mesajlar alacaksınız",
    userHasAlreadyAnotherId: "Bu telefon numarasına sahip kullanıcının farklı bir Viber kimliği var. Mevcut kullanıcılar için Viber-ID'yi yalnızca Yönetici değiştirme hakkına sahiptir",
    viberBotDisabledByAdmin: "ViberBot Yönetici tarafından devre dışı bırakıldı"
  },
  telegram: {
    telegramBotOnSubscribe: `Merhaba! Ben bir Telegram botuyum. Güncel görevler ve diğer bildirimler hakkında benden Viber üzerinden mesaj alabileceksiniz. 
      Ama önce seni tanımlamam gerekiyor. Bana telefon numaranızı şu formatta gönderin: +79100000000`,
    telegramBotNeedSubscribe: "Öncelikle seni tanımlamam gerekiyor. Telefon numaranızı şu formatta gönderin: +79100000000",
    telegramBotUnderstandOnlyTextMessages: "Üzgünüm. Yalnızca kısa mesajları anlıyorum",
    telegramBotDummyAnswer: "Bu sohbette yorum yazmaya gerek yoktur. Zaten onları kimse görmeyecek. Sohbet yalnızca tek yönlü çalışır Bot -> Telegram",
    telegramBotIsAlreadyKnownYou: "Telegram bot'ta zaten kayıtlısınız",
    userWithThisPhoneNotFound: "'users' veritabanında bu telefon numarasına sahip bir kullanıcı bulunamadı",
    telegramBotHello1: "Merhaba, ",
    telegramBotHello2: "! Kimliğiniz: ",
    telegramBotHello3: ". Bu sohbete başarıyla bağlandınız ve artık Telegram botundan mesajlar alacaksınız",
    userHasAlreadyAnotherId: "Bu telefon numarasına sahip kullanıcının farklı bir Telegram-ID'si var. Mevcut kullanıcıların Telegram ID'sini yalnızca Yönetici değiştirme hakkına sahiptir",
    telegramBotDisabledByAdmin: "TelegramBot Yönetici tarafından devre dışı bırakıldı",
    telegramBotUserIsNotAuthorizedToRunCommands: "Kullanıcının komutları yürütme yetkisi yok",
    telegramBotUserDoesntHavePermission: "Kullanıcının bu komutu yürütmek için yeterli izni yok",
    botMessageSelectACommandInMainMenu: "Telegram-bot ile çalışmaya başlamak için bir komut seçin",
    thereAreNoAwailCommandsForYou: "Kullanıcınızın hakları telgraf botundaki komutlara izin vermez",
    helloUserIamChatGPTansYouQuestion: "*Selamlar, %username%. 'Yapay Zeka Modu'nu seçtiniz. Sorunuzu Sor*",
    theMainComands: "Ana menüyü aramak için '*menu*' veya '*/menu*' yazın.\nChatgpt ile bir diyalog başlatmak için '*Merhaba*' yazın.\n"
    + "Dosyaları veya fotoğrafları sunucuya aktarmak için - '*dosyaları*' veya '*/files*' yazın. Dosyaların kaydedileceği bir 'site klasörü' seçebilirsiniz.\n"
    + "İşlemi kesintiye uğratmak, seyahat sayfalarını doldurmak veya başka bir modda olmak istiyorsanız, '*iptal*' veya '*/cancel*' yazın.\n"
    + "Yeni bir işlem başlatmak için (mevcut herhangi bir komutu aramak için) - '*menu*' yazın.\n"
    + "Telgraftaki metin alanı alanının sağında, düğmeyi tıkladığınızda bir düğme görünür - ana menü gizlenir veya gösterilir (böylece müdahale etmez)",
    wayBills: {
      startMessage1: "*= Seyahat sayfaları oluşturma ve geziler hesaplama şekli. Eylemi Seçin =*",
      startMessage2: "*= Seyahat sayfaları oluşturma ve geziler hesaplama şekli =\nEksik bir yolculuğunuz var:*\n",
      startActions: [
        {text: "🛣️ Kilometre ve yakıtı say", callback_data: "calcFuel"},
        {text: "🚗 Yeni bir gezi oluşturun", callback_data: "createNewTrip"},
        {text: "🏁 Önceki geziyi tamamlayın", callback_data: "finishLastTrip"},
        {text: "🛑 Ana menüye dön", callback_data: "menu"}
      ],
      selectedStartAction1: "_Kilometrenin hesaplama modu, zaman ve doğru miktarda yakıt (bir yol parçası oluşturmadan)_",
      selectedStartAction2: "_Bir Waybill'in yaratılmasının başlangıcı (varış zamanı 'B' noktasında varışta desteklenebilir)_",
      selectedStartAction3: "_Bitmemiş bir Way Shill'e veri girişinin tamamlanması_",
      selectAvto: "Bir Araba Seçin",
      selectedAvto: "Otomobil: _%selCar%_",
      selectFuelType: "Yakıt Türünü Seçin",
      selectedFuelType: "Yakıt: _%selFuel%_",
      selectConditions: "Çalışma Koşullarını Seçin",
      selectedConditions: "Koşullar: _%selCondition%_",
      startAddress: "Kalkış adresini girin",
      startAddressValue: "Kalkış adresi: _%startAddress%_",
      endAddress: "Randevu adresinizi girin",
      endAddressValue: "Randevu Adresi: _%endAddress%_",
      doYouWantToSetMiddleAddress: "Rotanın ara noktasının adresini belirtmek ister misiniz?",
      middleAddress: "Ara noktanın adresini girin",
      middleAddressValue: "Ara noktanın adresi: _%middleAddress%_",
      startDateTime: "Ayrılma tarihini ve saatini 'DD.MM.YYYY Saat:Min' biçiminde girin",
      endDateTime: "Varış tarihini ve saatini 'DD.MM.YYYY Saat:Min' biçiminde girin",
      endDateTimeLater: "Daha sonra dolduracağım, geldiğimde",
      odometerNum: "Hedef adrese varışta kilometre sayacı girin",
      odometerValue: "Varışta odomometre değeri - _%odometerValue%_",
      curTime: "Mevcut saat",
      startDateTimeValue: "Kalkış tarihi ve saati: _%startDateTime%_",
      endDateTimeValue: "Varış tarihi ve saati: _%endDateTime%_",
      tripIsCalculated: "🎯 Rota hesaplandı:\n*Kilometre = %mileage% km;\nAranan Zaman = %duration% zaman;\nHesaplanan yakıt miktarı = %fuel% l.",
      downloadWayBill: "📑 *Seyahat sayfası portal veritabanına kaydedilir*. Seyahat Sayfasını Link tarafından indirebilirsiniz:",
      yamapsBuilding: "Yandex-Maps açıyorum, rotayı oluşturuyorum. 30 saniye bekleyin lütfen...",
      doYouWantToContinueFillWayBill: "Seyahat sayfasını doldurmaya devam edecek miyiz?",
      goodBye: "Memnuniyetle yardım ettim! Güle güle.\n\n_Ana menüye dönmek için - 'menu' yazın_",
      createAnewTravelSheetNow: "Gerekli tüm verileri doldurdun.\n*Şimdi portalda bir yol bıçağı mı oluşturuyorsunuz?*",
      editTravelSheetNow: "Gerekli tüm verileri doldurdun.\n*Portaldaki mevcut yol bıçağında değişiklikler mi yapın?*",
      thereIsExistSimilarWaybill: "*Veritabanı zaten benzer bir seyahat sayfasına sahiptir. Bir kopya yaratmayacağım!*"
    },
    botMainMenu: "☰ Ana Menü ☰",
    botReturnToMainMenu: "🛑 Ana menüye dön",
    unknownCommand: "🚫 Bilinmeyen Komut",
    notDevelopedYet: "🅾️ Henüz kesinleşmedi...",
    youMustSelectInlineMenuItem: "⚠️ Listeden bir değer seçmelisiniz",
    // Program TelegramBot
    mainButtons: [
      {
        key: "generalFunctions1", title: ["🚙 Arabalarımız", "🛣️ Geziler"], cfgCompany: "smartteamdev"
      },
      {
        key: "generalFunctions2", title: ["🧾 Kasiyer çekleri", "💵 Maaş"], cfgCompany: "smartteamdev", safe: "hidden"
      },
      {
        key: "generalFunctions3", cfgCompany: "smartteamdev",
        title: ["🤖 ChatGPT", "🖥 Dosyalar - sunucuya", "☢️ Görevler"]},
      {
        key: "accounting", cfgCompany: "smartteamdev", visForGroups: [
          "GC-ADMINS", "GC-HEADSHIP", "GC-SECRETARY", "GC-ACCHEADER", "GC-LAB-NDT-HEADER", "GC-LAB-MEX-HEADER", "GC-LAB-STROY-HEADER", "GC-LAB-EL-HEADER",
          "ATL-HEADSHIP", "ATL-ACCHEADER", "ATL-SECRETARY"
        ],
        title: ["📄 Ödeme faturası", "💰 Alınan ödemeler", "🛂 SKUD"], safe: "hidden"
      },
      {
        key: "cancel", title: ["🛑 İptal etmek", "📒 Yardım"]
      }
    ],
    waitMessages: [
      "🤖 Düşünmem gerek...",
      "🤖 Düşünme...",
      "🤖 Hesaplama...",
      "🤖 Ne yapacağımı anlayacağım...",
      "🤖 Bir saniye...",
      "🤖 Verileri analiz ediyorum...",
      "🤖 Üzerinde çalışıyorum...",
      "🤖 Şimdi yapacağım...",
      "🤖 Vidaları bükmek...",
      "🤖 Sadece annemi arıyorum ve sorunuz için cevap vereceğim...",
      "🤖 Okulda okumadın mı? Yani yapacağım...",
      "🤖 Şimdi uyanıyorum ve yapıyorum...",
      "🤖 Danışmanlık için Houston'ı aramam gerekiyor...",
      "🤖 Pentagon'un kardeşi şimdi bize yardım edecek...",
      "🤖 Deepseek'e danışacağım..."
    ]
  },
  mattermost: {
    mattermostBotNeedSubscribe: "Öncelikle seni tanımlamam gerekiyor. Telefon numaranızı şu formatta gönderin: +79100000000",
    mattermostBotIsAlreadyKnownYou: "Mattermost bot'ta zaten kayıtlısınız",
    mattermostBotHello1: "Merhaba, ",
    mattermostBotHello2: "! Kimliğiniz: ",
    mattermostBotHello3: ". Bu sohbete başarıyla bağlandınız ve artık Mattermost botundan mesajlar alacaksınız",
    userHasAlreadyAnotherId: "Bu telefon numarasına sahip kullanıcının farklı bir Mattermost-ID'si var. Mevcut kullanıcıların Mattermost-ID'sini yalnızca Yönetici değiştirme hakkına sahiptir",
    mattermostBotDisabledByUser: "MattermostBot kullanıcı tarafından devre dışı bırakıldı",
    mattermostBotDisabledByAdmin: "MattermostBot Yönetici tarafından devre dışı bırakıldı",
    mbotCommandError: "Bu komutu çalıştırmak için yeterli haklara sahip değilsiniz",
    mbotUnknownCommand: "Bilinmeyen komut. Yardım için 'yardım' yazın",
    mbotDummyAnswer: "Botun mantıksal kısmı henüz kullanıcılardan gelen mesajları işleyemiyor",
    mattermostBotUserIsNotAuthorizedToRunCommands: "Kullanıcının komutları yürütme yetkisi yok",
    mattermostBotUserDoesntHavePermission: "Kullanıcının bu komutu yürütmek için yeterli izni yok",
    botMessageSelectACommandInMainMenu: "Mattermost-bot ile çalışmaya başlamak için bir komut seçin",
    thereAreNoAwailCommandsForYou: "Kullanıcınızın hakları Mattermost botundaki komutlara izin vermez",
    helloUserIamChatGPTansYouQuestion: "*Selamlar, %username%. 'Yapay Zeka Modu'nu seçtiniz. Sorunuzu Sor*",
    theMainComands: "Ana menüyü aramak için '*menu*' yazın.\nChatgpt ile bir diyalog başlatmak için '*Merhaba*' yazın.\n"
    + "Dosyaları veya fotoğrafları sunucuya aktarmak için - '*dosyaları*' yazın. Dosyaların kaydedileceği bir 'site klasörü' seçebilirsiniz.\n"
    + "İşlemi kesintiye uğratmak, seyahat sayfalarını doldurmak veya başka bir modda olmak istiyorsanız, '*iptal*' yazın.\n"
    + "Yeni bir işlem başlatmak için (mevcut herhangi bir komutu aramak için) - '*menu*' yazın.",
    wayBills: {
      startMessage1: "*= Seyahat sayfaları oluşturma ve geziler hesaplama şekli. Eylemi Seçin =*",
      startMessage2: "*= Seyahat sayfaları oluşturma ve geziler hesaplama şekli =\nEksik bir yolculuğunuz var:*\n",
      startActions: [
        {text: "🛣️ Kilometre ve yakıtı say", callback_data: "calcFuel"},
        {text: "🚗 Yeni bir gezi oluşturun", callback_data: "createNewTrip"},
        {text: "🏁 Önceki geziyi tamamlayın", callback_data: "finishLastTrip"},
        {text: "🛑 Iptal etmek", callback_data: "cancel"}
      ],
      selectedStartAction1: "*Kilometrenin hesaplama modu, zaman ve doğru miktarda yakıt (bir yol parçası oluşturmadan)*",
      selectedStartAction2: "*Bir Waybill'in yaratılmasının başlangıcı (varış zamanı 'B' noktasında varışta desteklenebilir)*",
      selectedStartAction3: "*Bitmemiş bir Way Shill'e veri girişinin tamamlanması*",
      modalDlgTitle1: "Parametreleri Seçin",
      submitButtonConfirmSelection: "Seçimi Onayla",
      submitButtonOK: "Tamam",
      selectAvto: "Bir Araba Seçin",
      selectedAvto: "Otomobil: *%selCar%*",
      selectFuelType: "Yakıt Türünü Seçin",
      selectedFuelType: "Yakıt: *%selFuel%*",
      selectConditions: "Çalışma Koşullarını Seçin",
      selectedConditions: "Koşullar: *%selCondition%*",
      selectedAvtoFuelConditions: "Otomobil: *%selCar%*; Yakıt: *%selFuel%*; Koşullar: *%selCondition%*",
      startAddress: "**Kalkış adresini girin**",
      startAddressValue: "Kalkış adresi: *%startAddress%*",
      endAddress: "**Randevu adresinizi girin**",
      endAddressValue: "Randevu Adresi: *%endAddress%*",
      doYouWantToSetMiddleAddress: "Rotanın ara noktasının adresini belirtmek ister misiniz?",
      typeTheAddresses: "*ROTA ADRES NOKTALARI*: girin",
      middleAddress: "**Ara noktanın adresini girin**",
      middleAddressValue: "Ara noktanın adresi: *%middleAddress%*",
      startDateTime: "**Ayrılma tarihini ve saatini 'DD.MM.YYYY Saat:Min' biçiminde girin**",
      endDateTime: "**Varış tarihini ve saatini 'DD.MM.YYYY Saat:Min' biçiminde girin**",
      endDateTimeLater: "Daha sonra dolduracağım, geldiğimde",
      odometerNum: "Hedef adrese varışta kilometre sayacı girin",
      odometerValue: "Varışta odomometre değeri - *%odometerValue%*",
      curTime: "Mevcut saat",
      startDateTimeValue: "Kalkış tarihi ve saati: *%startDateTime%*",
      endDateTimeValue: "Varış tarihi ve saati: *%endDateTime%*",
      tripIsCalculated: "🎯 Rota hesaplandı:\n*Kilometre = %mileage% km;\nAranan Zaman = %duration% zaman;\nHesaplanan yakıt miktarı = %fuel% l.",
      downloadWayBill: "📑 *Seyahat sayfası portal veritabanına kaydedilir*. Seyahat Sayfasını [link](%wayBillLink%) tarafından indirebilirsiniz:",
      yamapsBuilding: "Yandex-Maps açıyorum, rotayı oluşturuyorum. 30 saniye bekleyin lütfen...",
      doYouWantToContinueFillWayBill: "Seyahat sayfasını doldurmaya devam edecek miyiz?",
      goodBye: "Memnuniyetle yardım ettim! Güle güle.\n\n*Ana menüye dönmek için - 'menu' yazın*",
      createAnewTravelSheetNow: "Gerekli tüm verileri doldurdun.\n*Şimdi portalda bir yol bıçağı mı oluşturuyorsunuz?*",
      editTravelSheetNow: "Gerekli tüm verileri doldurdun.\n*Portaldaki mevcut yol bıçağında değişiklikler mi yapın?*",
      thereIsExistSimilarWaybill: "*Veritabanı zaten benzer bir seyahat sayfasına sahiptir. Bir kopya yaratmayacağım!*"
    },
    botReturnToMainMenu: "🛑 Ana menüye dön",
    unknownCommand: "🚫 Bilinmeyen Komut",
    notDevelopedYet: "🅾️ Henüz kesinleşmedi...",
    youMustSelectInlineMenuItem: "⚠️ Listeden bir değer seçmelisiniz",
    youMustTypeSomeTextInTheFields: "⚠️ Alanları, alanların anlamsal anlamlarına uygun olarak metinle doldurmalısınız",
    // Program MattermostBot
    mainButtons: [
      {
        key: "generalFunctions1", text: "Motor transport:", cfgCompany: "smartteamdev",
        actions: [{key: "avto", title: "🚙 Arabalarımız"}, {key: "trips", title: "🛣️ Geziler"}]
      },
      {
        key: "generalFunctions2", text: "My expenses and salary:", cfgCompany: "smartteamdev",
        actions: [{key: "cashierschecks", title: "🧾 Kasiyer çekleri"}, {key: "salary", title: "💵 Maaş", safe: "hidden"}]
      },
      {
        key: "generalFunctions3", text: "AI, Files, Tasks:", cfgCompany: "smartteamdev",
        actions: [{key: "chatgpt", title: "🤖 ChatGPT"}, {key: "files", title: "🖥 Dosyalar - sunucuya"}, {key: "tasks", title: "☢️ Görevler"}]
      },
      {
        key: "accounting", text: "Accounting", cfgCompany: "smartteamdev", safe: "hidden", visForGroups: [
          "GC-ADMINS", "GC-HEADSHIP", "GC-SECRETARY", "GC-ACCHEADER", "GC-LAB-NDT-HEADER", "GC-LAB-MEX-HEADER", "GC-LAB-STROY-HEADER", "GC-LAB-EL-HEADER",
          "ATL-HEADSHIP", "ATL-ACCHEADER", "ATL-SECRETARY"
        ],
        actions: [{key: "bill", title: "📄 Ödeme faturası"}, {key: "payments", title: "💰 Alınan ödemeler"}, {key: "skud", title: "🛂 SKUD"}]
      },
      {
        key: "cancel", text: "",
        actions: [{key: "cancel", title: "🛑 İptal etmek"}, {key: "help", title: "📒 Yardım"}]
      }
    ],
    waitMessages: [
      "🤖 Düşünmem gerek...",
      "🤖 Düşünme...",
      "🤖 Hesaplama...",
      "🤖 Ne yapacağımı anlayacağım...",
      "🤖 Bir saniye...",
      "🤖 Verileri analiz ediyorum...",
      "🤖 Üzerinde çalışıyorum...",
      "🤖 Şimdi yapacağım...",
      "🤖 Vidaları bükmek...",
      "🤖 Sadece annemi arıyorum ve sorunuz için cevap vereceğim...",
      "🤖 Okulda okumadın mı? Yani yapacağım...",
      "🤖 Şimdi uyanıyorum ve yapıyorum...",
      "🤖 Danışmanlık için Houston'ı aramam gerekiyor...",
      "🤖 Pentagon'un kardeşi şimdi bize yardım edecek...",
      "🤖 Deepseek'e danışacağım..."
    ]
  },
  chatGPT: {
    thinking: "✍🏼 Düşünmek...",
    botGeneratingAnswer: "Bot bir yanıt oluşturur..."
  },
  api1c: {
    c1disabled: "API 1C modülü yönetici tarafından devre dışı bırakıldı",
    c1LinkIsNull: "Program ayarlarında 'API 1C URI' eksik",
    c1AuthIsNull: "Program ayarlarında 'API 1C muhasebe verilerini' eksik",
    accessDenied: "'API 1C (OData)' ye erişim yasaktır. Yanlış Muhasebe Verileri",
    cantFind1Cserver: "Program ayarlarında bu işleve uygun bir 1C sunucusu bulamadım",
    dbNameNotSpecified: "Veritabanı adı belirtilmedi",
    companyNotSpecified: "Şirket adı belirtilmedi",
    cantGetAnyRecordsets: "1C'den hiçbir kayıt alınamadı",
    unknownError: "API 1C (oData) erişiminde bilinmeyen bir hata oluştu"
  },

  /// ===========  site =========== ///

  navbar: {
    logoText: "SmartTeamDev",
    home: "Ana Sayfa",
    portal: "Portal",
    services: "Servisler",
    media: "Medya",
    contact: "Iletisim",
    requestDemo: "Demo surumu",
    languageLabel: "Dil",
    langRu: "Rusca",
    langEn: "Ingilizce",
    langTr: "Turkce",
    menuAriaLabel: "SmartTeamDev menusu",
    hamburgerAriaLabel: "Menuyu ac"
  },
  footer: {
    logoText: "SmartTeamDev",
    description: "Ekipler icin kurumsal portal ve dijital servisler.",
    productsTitle: "Bolumler",
    productPortal: "Portal",
    productServices: "Servisler",
    productProjects: "Projeler",
    productMedia: "Medya",
    companyTitle: "Sirket",
    companyContact: "Iletisim",
    companyPrivacy: "Gizlilik",
    companyDocs: "Dokumanlar",
    companySupport: "Destek",
    contactsTitle: "Iletisim",
    phone: "+7 (495) 123-45-67",
    email: "demo@smartteamdev.ru",
    address: "Moskova, demo ofis",
    copyright: "© 2026 SmartTeamDev",
    scrollTopAriaLabel: "Yukari"
  },
  common: {
    title: "SmartTeamDev",
    description: "SmartTeamDev demo sitesi",
    loading: "Yukleniyor",
    error: "Hata",
    close: "Kapat"
  }
};
